// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RouteContact" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const RouteContactGenShape = z.strictObject({
  telephone: z.string().optional(),
  email: z.string().optional(),
  emergencyContact: z.string().optional(),
  address: z.string().optional(),
  selfReferralUrl: z.string().optional(),
  information: z.string().optional(),
});
